import React, { Fragment, Component } from 'react';
import { Select } from 'antd';
import _ from 'lodash';
import { ApartmentOutlined, FormOutlined } from '@ant-design/icons';
import PowerSelectPanel from './powerSelectPanel';
import { IMPEDANCE_PACKAGE, IMPEDANCE_PACKAGE_FILE } from '../../../services/Cascade/constants';
import PackageRelationship from './packageRelationship';

class TargetDie extends Component {

  constructor(props) {
    super(props);
    this.state = {
      die: [],
      focus: false,
      relationshipOpen: false
    }
  }

  componentDidMount() {
    const { die } = this.props;
    this.setState({
      die
    })
  }

  componentDidUpdate(prevProps) {
    const { die } = this.props;
    if (!_.isEqual(die, prevProps.die)) {
      this.setState({
        die
      })
    }
  }

  selectDie = (die) => {
    this.setState({
      die
    })
  }

  saveDie = () => {
    const { die } = this.state;
    this.props.dieSelect(die);
    this.setState({
      focus: false
    })
  }

  onFocus = () => {
    this.setState({
      focus: true
    })
  }

  closePanel = () => {
    this.changePanelStatus(false);
  }

  changePanelStatus = (bool, e, isLoadingNets) => {
    e && e.preventDefault() && e.stopPropagation();
    const { updateOpenTargetDieLoading, updateSelectPowerNets } = this.props;
    bool && updateOpenTargetDieLoading && updateOpenTargetDieLoading(true);
    updateSelectPowerNets({ open: bool, isLoadingNets });
  }

  changeRelationOpen = (e, boolean) => {
    e && e.stopPropagation()
    this.setState({
      relationshipOpen: boolean
    })
  }

  render() {
    const { options, noPCB, loading, disabled = false, openTargetDieLoading, powerNetSelect = {}, designType, singleLayout, packageDesignId, packageRelationship, packageType } = this.props;
    const { open = false, select = [], allPowerNets = [], allNets = [] } = powerNetSelect || {};
    const { die, focus, relationshipOpen } = this.state;
    return (
      <Fragment>
        <span className="font-bold cascade-setup-title-color-only">Die</span>
        <Select
          mode={focus ? 'multiple' : null}
          value={!focus && die && die.length ? die.join(', ') : die}
          style={{ width: 240, marginLeft: 20 }}
          onChange={this.selectDie}
          onBlur={this.saveDie}
          onFocus={this.onFocus}
          getPopupContainer={((trigger) => trigger.parentNode || document.getElementById('root'))}
          styles={{ popup: { root: { zIndex: 200 } } }}
          showSearch={true}
          disabled={noPCB || loading ? true : disabled}
          options={options.map(option => ({
            value: option,
            label: option
          }))}
        />
        {designType === IMPEDANCE_PACKAGE && die && die.length && !packageDesignId && singleLayout ? <FormOutlined
          className="cascade-refresh-icon"
          style={open || loading ? { color: "rgba(0,0,0,0.65)", cursor: "not-allowed" } : {}}
          title="Select Power Nets"
          onClick={(e) => open || loading ? null : this.changePanelStatus(true, e, true)} /> : null}
        {
          packageType !== IMPEDANCE_PACKAGE_FILE && packageDesignId && !singleLayout ? <ApartmentOutlined
            className="cascade-refresh-icon"
            style={open || loading ? { color: "rgba(0,0,0,0.65)", cursor: "not-allowed" } : {}}
            title="Package and PCB nets relationship"
            onClick={(e) => this.changeRelationOpen(e, true)} /> : null
        }
        {designType === IMPEDANCE_PACKAGE && open && !packageDesignId && singleLayout ? <PowerSelectPanel
          closePanel={this.closePanel}
          select={select}
          openLoading={openTargetDieLoading || false}
          allPowerNets={allPowerNets}
          refresh={this.props.refresh}
          comp={die.join(', ')}
          allNets={allNets}
        /> : null}
        {
          relationshipOpen ? <PackageRelationship
            onCancel={() => this.changeRelationOpen(null, false)}
            packageDesignId={packageDesignId}
            packageRelationship={packageRelationship}
            updatePackageRelationship={this.props.updatePackageRelationship}
          /> : null
        }
      </Fragment>
    )
  }
}

export default TargetDie;